import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type MatterNote,
  type MatterNoteWithComments,
} from "@/lib/types";

type AnnotationParentInput =
  | { matterId: string; massTortId?: never }
  | { matterId?: never; massTortId: string };

type MatterNoteAssociationFields = Pick<
  MatterNote,
  | "emailId"
  | "expenseId"
  | "fileId"
  | "incidentReportId"
  | "insuranceId"
  | "lienId"
  | "litigationDateId"
  | "lostWagesId"
  | "medicalTreatmentAppointmentId"
  | "medicalTreatmentBalanceConfirmationId"
  | "medicalTreatmentBillId"
  | "medicalTreatmentId"
  | "medicalTreatmentPlanId"
  | "medicalTreatmentRecordId"
  | "propertyDamageId"
  | "settlementCounterId"
  | "settlementDemandId"
  | "settlementOfferId"
  | "shareFolderId"
  | "signatureRequestId"
  | "statuteOfLimitationsId"
  | "trustCheckId"
  | "vehicleId"
>;

type CreateMatterNoteInput = AnnotationParentInput &
  Pick<MatterNote, "message" | "draft" | "pinned" | "userId"> &
  Partial<MatterNoteAssociationFields>;

type UpdateMatterNoteInput = AnnotationParentInput &
  Pick<MatterNote, "id" | "dateModified"> &
  Partial<
    Pick<MatterNote, "message" | "draft" | "pinned" | "userId"> &
      MatterNoteAssociationFields
  >;

export const createMatterNoteV1 = (data: CreateMatterNoteInput) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<APIResponse<MatterNote>>(`${baseFastApiMatterRoute}/notes`, data)
    .then((res) => res.data);
};

export const updateMatterNoteV1 = (data: UpdateMatterNoteInput) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<APIResponse<MatterNote>>(`${baseFastApiMatterRoute}/notes`, data)
    .then((res) => res.data);
};

export const deleteMatterNoteV1 = (
  data: Pick<MatterNote, "id"> & AnnotationParentInput,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<APIResponse<MatterNote>>(`${baseFastApiMatterRoute}/notes/${id}`)
    .then((res) => res.data);
};

export type RetrieveMatterNotesParams = {
  matterId: string;
  pageNumber?: number;
  pageSize?: number;
};

export const retrieveMatterNotesV2 = ({
  matterId,
  pageNumber = 1,
  pageSize = 1000,
}: RetrieveMatterNotesParams) =>
  authenticatedFastApiAxiosInstanceAllowEmptyString
    .get<
      APIResponse<MatterNoteWithComments[]>
    >(`${baseFastApiMatterRoute}/${matterId}/notes`, { params: { pageNumber, pageSize } })
    .then((res) => res.data);
